import React, { useState, useEffect } from 'react'
import { Panel, Col, FlexboxGrid } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isValidators } from '../../../utils/ValidatorUtils'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import InputForm from '../../../components/forms/input/InputForm'
import InputNumberForm from '../../../components/forms/input/InputNumberForm'
import InputDateForm from '../../../components/forms/input/InputDateForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'

export default function ManageDurableArticlesManageDetail({
  schema,
  closureTypes = [],
  onApply = () => {},
  ...props
}) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [tableData, setTableData] = useState([])

  const onSubmit = (data) => {
    onApply(data)
  }

  return (
    <>
      <div style={{ marginBottom: 10 }}>
        {closureTypes?.includes('1') && (
          <div style={{ marginTop: 10 }}>
            <b>สำหรับรูปแบบบริหารจัดการ ส่งคืน สสส.</b>
            <FlexboxGrid>
              {schema.reserveProject && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputSelectForm
                    schema={schema.reserveProject}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </FlexboxGrid.Item>
              )}

              {schema.reserveProjectState && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputForm
                    schema={schema.reserveProjectState}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
          </div>
        )}

        {closureTypes?.includes('2') && (
          <div style={{ marginTop: 10 }}>
            <b>สำหรับรูปแบบบริหารจัดการ ขาย</b>
            <FlexboxGrid>
              {schema.buyerName && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputForm
                    schema={schema.buyerName}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </FlexboxGrid.Item>
              )}

              {schema.salePrice && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputNumberForm
                    schema={schema.salePrice}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </FlexboxGrid.Item>
              )}

              {schema.billIngDocNo && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputForm
                    schema={schema.billIngDocNo}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </FlexboxGrid.Item>
              )}

              {schema.billIngDate && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputDateForm
                    schema={schema.billIngDate}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    //startDate={sessionGetItemStr('projectStartDate')}
                    endDate={new Date()}
                  />
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
          </div>
        )}

        {closureTypes?.includes('3') && (
          <div style={{ marginTop: 10 }}>
            <b>สำหรับรูปแบบบริหารจัดการ บริจาค</b>
            <FlexboxGrid>
              {schema.donateToName && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputForm
                    schema={schema.donateToName}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </FlexboxGrid.Item>
              )}
              {schema.donateDocNo && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputForm
                    schema={schema.donateDocNo}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </FlexboxGrid.Item>
              )}
              {schema.donateDocDate && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputDateForm
                    schema={schema.donateDocDate}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    //startDate={sessionGetItemStr('projectStartDate')}
                    endDate={new Date()}
                  />
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
          </div>
        )}

        {closureTypes?.includes('4') && (
          <div style={{ marginTop: 10 }}>
            <b>สำหรับรูปแบบบริหารจัดการ โอนระหว่างโครงการ</b>
            <FlexboxGrid>
              {schema.transferredProject && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputSelectForm
                    schema={schema.transferredProject}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
          </div>
        )}

        {closureTypes?.includes('5') && (
          <div style={{ marginTop: 10 }}>
            <b>สำหรับรูปแบบบริหารจัดการ แปลสภาพ/ทำลาย</b>
            <FlexboxGrid>
              {schema.destroyDate && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputDateForm
                    schema={schema.destroyDate}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    //startDate={sessionGetItemStr('projectStartDate')}
                    endDate={new Date()}
                  />
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
          </div>
        )}

        {closureTypes?.includes('6') && (
          <div style={{ marginTop: 10 }}>
            <b>สำหรับรูปแบบบริหารจัดการ แลกเปลี่ยน</b>
            <FlexboxGrid>
              {schema.exchangeOrg && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputForm
                    schema={schema.exchangeOrg}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </FlexboxGrid.Item>
              )}

              {schema.exchangeDate && (
                <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={6} lg={6}>
                  <InputDateForm
                    schema={schema.exchangeDate}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    //startDate={sessionGetItemStr('projectStartDate')}
                    endDate={new Date()}
                  />
                </FlexboxGrid.Item>
              )}
            </FlexboxGrid>
          </div>
        )}

        <SaveButton
          style={{ marginTop: 10 }}
          icon="check-circle"
          children="นำไปใช้กับรายการที่เลือก"
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </>
  )
}
